<template>
  <section>
    <resource
      title="Ändern"
      resource="gift"
      resourceName="Geschenk"
      :withFiles="true"
      :original="original"
      :attributes="[
        {
          name: 'title',
          label: 'Name'
        },
        {
          name: 'gift_category_id',
          label: 'Kategorie',
          type: 'DropdownResourceSelector',
          resource: 'giftCategory',
          nullValue: 'Keine Kategorie (Allgemein)',
          filter: [
            {
              name: 'sort',
              mode: 'ASC',
              attribute: 'name'
            },
            {
              name: 'forSelect'
            }
          ]
        },
        {
          name: 'price',
          label: 'Preis'
        },
        {
          name: 'royalty',
          label: 'Mod Preis'
        },
        {
          name: 'id',
          label: 'Bild',
          type: 'ImageSelector',
          updateMode: true
        }
      ]"
    >
      <div slot="title">
        <h4>Geschenk bearbeiten</h4>
      </div>
    </resource>
  </section>
</template>

<script lang="babel">
import store from "@/store";

export default {
  beforeRouteEnter (to, from, next) {
    store.dispatch('gift/read', [
      {
        name: 'where',
        attributes: {
          id : [Number(to.params.id)],
        }
      },
    ]).then(() => {
      next();
    });
  },
  computed: {
    id() {
      return Number(this.$route.params.id);
    },
    original() {
      return this.$store.getters['gift/find'](this.id);
    },
    updateUrl() {
      return this.original !== undefined ? this.original.update_url : "";
    }
  },
  mounted() {
      this.$bus.$on('media-uploaded', () => {
        this.$router.push({ path: `/geschenk/liste` });
      });
  }
}
</script>
